import { Container } from "react-bootstrap";
import "./App.css";
import File from "./comps/File";
import ListComp from "./comps/ListComp";

function App() {
  return (
    <Container className="container d-flex justify-content-center flex-column align-items-center text-center my-2">
      <h1 className="main_header">
        My File-Uploader{" "}
        <p className="small">
          (Powered By Firebase)
          <br />
          <small>(Max Size 3 Mb)</small>
        </p>
      </h1>

      {/* file upload form */}
      <File />
      {/* list display */}
      <ListComp />
    </Container>
  );
}

export default App;
